<template>
    <div style="height:auto;"  v-loading.fullscreen.lock="fullscreenLoading">
        <iframe style="width:100%;min-height: 85vh" :src="btn_tpl_url" ref="iframe" frameborder="0"  id="bdIframe"></iframe>
    </div>
</template>

<script>
    import { templateLink } from '../../../api/templateList';

    export default {
        name: 'iframePage',
        data(){
          return{
              btn_tpl_url:'',
              fullscreenLoading:false
          }
        },
        mounted(){
            /**
             * iframe-宽高自适应显示
            //  */
            // const oIframe = document.getElementById('bdIframe');
            // const deviceWidth = document.documentElement.clientWidth;
            // const deviceHeight = document.documentElement.clientHeight;
            // oIframe.style.width = (Number(deviceWidth)) + 'px'; //数字是页面布局宽度差值
            // oIframe.style.height = (Number(deviceHeight)-120) + 'px'; //数字是页面布局高度差
            // oIframe.style.width = deviceWidth + 'px';
            // oIframe.style.height = deviceHeight + 'px';
        },
        created() {
            this.fullscreenLoading=true
            templateLink(this.$route.query.sn).then(res=>{
                if (res.code==200){
                    this.fullscreenLoading=false
                    this.btn_tpl_url=res.data.btn_tpl_url
                }
            })
        }
    };
</script>

<style scoped>

</style>
